export default "__VITE_ASSET__2pehJTJZ__"